import { render, staticRenderFns } from "./resellers.vue?vue&type=template&id=23abd840&"
import script from "./resellers.vue?vue&type=script&lang=js&"
export * from "./resellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports